/* src/app/_shared/components/item/item.component.scss */
:host {
  display: block;
  margin: 0 calc(var(--space-right) / 2) 0 calc(var(--space-left) / 2);
  border-bottom: 1px solid var(--ion-color-light);
  overflow: overlay;
  --item-background: #FFFFFF;
  --item-column-icon: auto;
  --item-column-content: minmax(0, 1fr);
  --item-column-detail-icon: 24px;
  --item-content-padding-left: var(--space-left);
  --item-content-padding-right: var(--space-right);
  --detail-icon-color: var(--ion-color-primary);
  --icon-color: var(--ion-color-action);
  --icon-margin: var(--space-right);
  --icon-font-size: var(--icon-size);
  --padding-top: var(--space-top);
  --padding-bottom: var(--space-bottom);
  --padding-left: calc(var(--space-left) / 2);
  --min-height: unset;
  --item-width: auto;
  --content-justify: unset;
}
:host[iconColor=action],
:host[ng-reflect-icon-color=action] {
  --icon-color: var(--ion-color-action);
}
:host[iconColor=light],
:host[ng-reflect-icon-color=light] {
  --icon-color: var(--ion-color-light);
}
:host[iconColor=dark],
:host[ng-reflect-icon-color=dark] {
  --icon-color: var(--color-dark);
}
:host[disabled=true],
:host[disabled],
:host[ng-reflect-disabled=true] {
  --detail-icon-color: var(--ion-color-light);
  --icon-color: var(--ion-color-light);
}
:host[lines=none] {
  border-bottom: none;
}
:host[multiline=true] .flow-item ::ng-deep ion-label,
:host[ng-reflect-multiline=true] .flow-item ::ng-deep ion-label {
  white-space: normal;
}
:host[icon],
:host[ng-reflect-icon] {
  --item-column-icon: 24px;
  --item-content-padding-left: var(--icon-margin);
}
:host[detail-icon=false],
:host[ng-reflect-detail-icon=false] {
  --item-column-detail-icon: 0;
  --item-content-padding-right: 0;
}
:host:focus,
:host:active {
  outline: none;
}
.flow-item {
  display: grid;
  grid-template-columns: var(--item-column-icon) var(--item-column-content) var(--item-column-detail-icon);
  grid-template-rows: 1fr;
  align-items: center;
  min-height: var(--min-height);
  padding: var(--padding-top) calc(var(--space-right) / 2) var(--padding-bottom) var(--padding-left);
  background-color: var(--item-background);
  width: var(--item-width);
}
.flow-item .content-container {
  display: flex;
  align-items: center;
  padding-left: var(--item-content-padding-left);
  padding-right: var(--item-content-padding-right);
  justify-content: var(--content-justify);
}
.flow-item .content-container :host ion-select::part(icon) {
  color: var(--ion-color-medium);
}
.flow-item .icon-container,
.flow-item .detail-icon-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.flow-item ion-icon {
  justify-self: flex-start;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--icon-color);
  font-size: var(--icon-font-size);
}
.flow-item ion-icon.detail-icon {
  color: var(--detail-icon-color);
}
ion-select {
  border: 1px solid var(--ion-color-medium);
}
/*# sourceMappingURL=item.component-6XBKRIWB.css.map */
